module.exports = __webpack_public_path__ + "img/993483d.jpg";